import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default function TotalSalesByCategoryChart(props) {
  const { statistics, loading } = useSelector((state) => state.Dashboard);
  const chartRef = useRef();

  useEffect(() => {
    if (chartRef && chartRef.current) {
      var areaData = {
        labels: statistics?.sales_by_category
          ?.filter((item) => {
            return item["_id"] != "Skin Care";
          })
          ?.map((item) => {
            return item["_id"];
          }),
        datasets: [
          {
            data: statistics?.sales_by_category
              ?.filter((item) => {
                return item["_id"] != "Skin Care";
              })
              ?.map((item) => {
                return item["sales_by_category"];
              }),
            backgroundColor: statistics?.sales_by_category
              ?.filter((item) => {
                return item["_id"] != "Skin Care";
              })
              ?.map((item) => {
                return item["color"];
              }),
            borderColor: "rgba(0,0,0,0)",
          },
        ],
      };
      console.log(areaData);
      var areaOptions = {
        responsive: true,
        maintainAspectRatio: true,
        segmentShowStroke: false,
        cutoutPercentage: 55,
        elements: {
          arc: {
            borderWidth: 4,
          },
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
        },
      };
      var onlineSalesChartCanvas = chartRef?.current?.getContext("2d");
      var onlineSalesChart = new window.Chart(onlineSalesChartCanvas, {
        type: "doughnut",
        data: areaData,
        options: areaOptions,
      });
    }
  }, [statistics]);

  return (
    <>
      <canvas ref={chartRef} className="mt-5 mt-md-3 mt-xl-5"></canvas>
      <div
        className="row"
        style={{
          fontSize: 8,
          color: "#808080",
          paddingTop: 26,
        }}
      >
        {statistics?.sales_by_category
          ?.filter((item) => {
            return item["_id"] != "Skin Care";
          })
          ?.map((item) => (
            <div className="col-md-6 col-sm-6 col-lg-6">
              <div
                style={{
                  width: 20,
                  height: 10,
                  backgroundColor: item?.color || "#e5e5e5",
                  display: "inline-block",
                }}
              ></div>{" "}
              {item["_id"]}
            </div>
          ))}
      </div>
    </>
  );
}
